import type { AuthConfirmationMethod } from '@/types/auth';

export const AuthStepKeys = {
  otpReady: 'auth:otpReady',
  registerReady: 'auth:registerReady',
  phoneConfirmReady: 'auth:phoneConfirmReady',
  confirmMethod: 'auth:confirmMethod',
} as const;

export const authStep = {
  markPhoneConfirmReady(): void {
    window.sessionStorage.setItem(AuthStepKeys.phoneConfirmReady, '1');
  },
  clearPhoneConfirmReady(): void {
    window.sessionStorage.removeItem(AuthStepKeys.phoneConfirmReady);
  },
  isPhoneConfirmReady(): boolean {
    return window.sessionStorage.getItem(AuthStepKeys.phoneConfirmReady) === '1';
  },

  setConfirmMethod(method: AuthConfirmationMethod): void {
    window.sessionStorage.setItem(AuthStepKeys.confirmMethod, method);
  },
  getConfirmMethod(): AuthConfirmationMethod | null {
    const method = window.sessionStorage.getItem(AuthStepKeys.confirmMethod);
    if (method === 'sms' || method === 'call') {
      return method;
    }
    return null;
  },
  clearConfirmMethod(): void {
    window.sessionStorage.removeItem(AuthStepKeys.confirmMethod);
  },

  markOtpReady(): void {
    window.sessionStorage.setItem(AuthStepKeys.otpReady, '1');
  },
  clearOtpReady(): void {
    window.sessionStorage.removeItem(AuthStepKeys.otpReady);
  },
  isOtpReady(): boolean {
    return window.sessionStorage.getItem(AuthStepKeys.otpReady) === '1';
  },

  markRegisterReady(): void {
    window.sessionStorage.setItem(AuthStepKeys.registerReady, '1');
  },
  clearRegisterReady(): void {
    window.sessionStorage.removeItem(AuthStepKeys.registerReady);
  },
  isRegisterReady(): boolean {
    return window.sessionStorage.getItem(AuthStepKeys.registerReady) === '1';
  },

  clearAll(): void {
    authStep.clearPhoneConfirmReady();
    authStep.clearConfirmMethod();
    authStep.clearOtpReady();
    authStep.clearRegisterReady();
  },
};
